var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blockquote',{staticClass:"com-news-source"},[_c('span',[_vm._v("文章来源: ")]),_c('span',{staticClass:"news-link",on:{"click":_vm.linkToSource}},[_vm._v(_vm._s(_vm.dataInfo.source))])])
}
var staticRenderFns = []

export { render, staticRenderFns }